import React from 'react';
import "./FeedCardMediaLocked.scss";
import { apiCropImage } from '../../../../config';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faWarning,
  faUnlock,
} from "@fortawesome/pro-regular-svg-icons";
import { MEDIA_LOCKED_LABEL } from '../../../../hooks/useMediaLocked';
import {faBadgeCheck} from "@fortawesome/pro-solid-svg-icons";

const FeedCardMediaLocked = ({media, lockedReason, handleLockedAction})=>{
    let uri = Array.isArray(media.previewUrl) ? media.previewUrl[0] : media.previewUrl;
    
    const labels = {
        [MEDIA_LOCKED_LABEL.BIG_PLAN] : 'Voir les gros plans',
        [MEDIA_LOCKED_LABEL.FRIENDS] : 'Réservé à son cercle',
        [MEDIA_LOCKED_LABEL.CERTIFIED] : 'Exclusif aux certifiés',
        [MEDIA_LOCKED_LABEL.MEMBERS_ONLY] : 'Exclusif aux connectés',
        [MEDIA_LOCKED_LABEL.INVISIBLE] : 'Bloqué',
    }
    
    const renderContent = ()=>{
        if ([MEDIA_LOCKED_LABEL.FRIENDS, MEDIA_LOCKED_LABEL.MEMBERS_ONLY].includes(lockedReason)) {
            return (
                <>
                    {labels[lockedReason]}
                    <div className="hf-feed-card-media-locked-cta">
                        <FontAwesomeIcon icon={faUnlock} /> Rejoindre
                    </div>
                </>
            )
        }
        else if(lockedReason === MEDIA_LOCKED_LABEL.BIG_PLAN){
            return (
                <>
                    <div className="hf-feed-card-media-locked-cta">
                        <FontAwesomeIcon icon={faEye} /> {labels[lockedReason]}
                    </div>
                    
                </>
            )
        }
        else if(lockedReason === MEDIA_LOCKED_LABEL.CERTIFIED){
            return (
                <>
                    {labels[lockedReason]}
                    <div className="hf-feed-card-media-locked-cta">
                        <FontAwesomeIcon icon={faBadgeCheck} /> Me certifier
                    </div>

                </>
            )
        }
        else {
            return (
                <>
                    <div className="hf-feed-card-media-locked-icon">
                        <FontAwesomeIcon icon={faWarning} />
                    </div>
                    {labels[lockedReason]}
                </>
            )
        }
    }

    return (
        <div className={`hf-feed-card-media-locked plausible-event-name=LOCKED_${lockedReason}`} onClick={handleLockedAction}>
            <img
                    src={apiCropImage({ url: uri, width: 100, height:100, quality:12})}
                    alt={uri}
                />
            <div className="hf-feed-card-media-locked-wrapper">
                {renderContent()}
            </div>
        </div>
    )
}

export default React.memo(FeedCardMediaLocked);